import { mapActions } from 'vuex'
import { cloneDeep } from 'lodash'
import tagAddEditContent from '@/components/pages/main-pages/settings/tags/tag-add-edit-content/tag-add-edit-content.vue'

export default {
  components: {
    tagAddEditContent
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      tag: {}
    }
  },
  methods: {
    ...mapActions('tag', ['updateTag', 'deleteTag', 'getTags']),
    onUpdateTag: async function () {
      try {
        const editedTag = cloneDeep(this.data)
        await this.updateTag(editedTag)
        this.$notify({
          text: 'Tag updated',
          type: 'success'
        })
        this.data.edit(this.data.id)
        this.getTags()
      } catch (e) {
        this.$notify({
          text: 'Error while updating tag',
          type: 'error'
        })
      }
    },
    cancel: function () {
      this.data.edit(this.data.id)
    },
    onDelete: async function () {
      try {
        await this.$dialog.confirm(`Do you really want to delete tag ${this.data.name}?`)
        await this.deleteTag({
          id: this.data.id
        })
        this.$notify({
          text: 'tag deleted',
          type: 'success'
        })
        this.data.edit(this.data.id)
        this.getTags()
      } catch (error) {
        this.$notify({
          text: 'Error while deleting tag',
          type: 'error'
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/main-pages/settings/tags/tag-edit/tag-edit.js